/**
 * Enum for order source types.
 * @readonly
 * @enum {Number} SourceTypeEnum
 */

const SourceTypeEnum = {
  ALL          : 0,
  ONLINE       : 1,
  ONLINE_TABLE : 6,
  ONLINE_BOOTH : 7,
  ONLINE_ROOM  : 8,
  ONLINE_SUNBED: 9,
  MOBILE       : 10,
  MARKETPLACE  : 11,

  /** @type {Array} */
  get ONLINE_SOURCES () {
    return [this.ONLINE, this.ONLINE_TABLE, this.ONLINE_BOOTH, this.ONLINE_ROOM, this.ONLINE_SUNBED, this.MOBILE, this.MARKETPLACE]
  },

  /** @type {Array} */
  get ONLINE_QR_SOURCES () {
    return [this.ONLINE_TABLE, this.ONLINE_BOOTH, this.ONLINE_ROOM, this.ONLINE_SUNBED]
  }
}

export default SourceTypeEnum
